import { chakra, JsxStyleProps } from "@chakra-ui/react";
import { Link } from "react-router";

/**
 *
 * This component checks if the passed in href is an external link or not
 * If the link is external, an anchor tag (for accessibility) that opens a new window
 * Else, renders a react router link to keep history stack accurate and prevent refreshes
 */

const ChakraLink = chakra(Link);
const ChakraAnchor = chakra("a");
export const SmartLink = ({
  href,
  children,
  ...props
}: {
  href: string | null | undefined;
  children: React.ReactNode;
} & JsxStyleProps) => {
  if (!href) return <>{children}</>;
  const isExternal = href.startsWith("http");
  if (isExternal) {
    return (
      <ChakraAnchor href={href} target="_blank" rel="noopener noreferrer" {...props}>
        {children}
      </ChakraAnchor>
    );
  } else {
    return (
      <ChakraLink to={href} {...props}>
        {children}
      </ChakraLink>
    );
  }
};
